import { render, staticRenderFns } from "./listWall.vue?vue&type=template&id=66be859a&scoped=true&"
import script from "./listWall.vue?vue&type=script&lang=js&"
export * from "./listWall.vue?vue&type=script&lang=js&"
import style0 from "./listWall.vue?vue&type=style&index=0&id=66be859a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be859a",
  null
  
)

export default component.exports